import o from "./_asciiToArray.js";
import a from "./_hasUnicode.js";
import i from "./_unicodeToArray.js";
function f(r) {
  return a(r) ? i(r) : o(r);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stringToArray.js
// module id = 1554
// module chunks = 67